// extracted by mini-css-extract-plugin
module.exports = {"container":"TunerHome_container__39K4t","h1text":"TunerHome_h1text__1THU6","h2text":"TunerHome_h2text__2NsH4","smaller":"TunerHome_smaller__QRd4d"};